"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HotelAISummary: ()=>HotelAISummary,
    HotelAISummaryMemo: ()=>HotelAISummaryMemo
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_generateHotelSummary_js_namespaceObject = require("../generateHotelSummary.js");
const useChatMessagesContext_js_namespaceObject = require("../../hooks/useChatMessagesContext.js");
const HotelAISummary = ({ shouldDisplayGenHotelFeature, propertyName, isExpressDeal, fetchRequestOptions, description, starRating, hotelAmenities, petDescription })=>{
    const [summary, setSummary] = (0, external_react_namespaceObject.useState)('');
    const { chatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    (0, external_react_namespaceObject.useEffect)(()=>{
        let intervalId;
        let mounted = true;
        if (!isExpressDeal && shouldDisplayGenHotelFeature && propertyName) {
            const hotelDetail = {
                hotelName: propertyName,
                description,
                starRating,
                hotelFeatures: hotelAmenities?.map((feature)=>feature.name),
                petPolicy: petDescription
            };
            external_generateHotelSummary_js_namespaceObject.hotelSummaryManager.addHotelSummary(propertyName, {
                prompts: chatMessages?.filter((msg)=>!!msg.content),
                source: 'newHotelListingCard',
                fetchRequestOptions,
                hotelDetail
            });
            const checkSummary = ()=>{
                const summaryResult = external_generateHotelSummary_js_namespaceObject.hotelSummaryManager.getHotelSummary(propertyName);
                if (mounted) {
                    summaryResult?.status !== 'ERROR' ? setSummary(summaryResult?.text || '') : setSummary('');
                    if (summaryResult?.status === 'DONE' || summaryResult?.status === 'ERROR') {
                        if (intervalId) clearInterval(intervalId);
                    }
                }
            };
            checkSummary();
            intervalId = setInterval(checkSummary, 200);
        }
        return ()=>{
            mounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        propertyName,
        isExpressDeal,
        shouldDisplayGenHotelFeature,
        description,
        starRating,
        hotelAmenities,
        petDescription,
        fetchRequestOptions
    ]);
    if (!summary) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        "data-testid": "hotel-ai-summary",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
            fontSize: 0,
            lineHeight: "20px",
            pb: 1,
            pt: 2,
            children: summary
        })
    });
};
const HotelAISummaryMemo = /*#__PURE__*/ external_react_default().memo(HotelAISummary, (prev, next)=>prev.propertyName === next.propertyName);
HotelAISummaryMemo.displayName = 'HotelAISummary';
exports.HotelAISummary = __webpack_exports__.HotelAISummary;
exports.HotelAISummaryMemo = __webpack_exports__.HotelAISummaryMemo;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HotelAISummary",
    "HotelAISummaryMemo"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
